/**
 * Client-side admin check.
 *
 * Reads VITE_HARVEST_ADMIN_UIDS (comma-separated Firebase UIDs).
 * When unset, no UID is treated as admin — Harvest nav is hidden for everyone.
 * The API enforces the real gate server-side; this is purely a UI filter.
 */
const ADMIN_UIDS: Set<string> = new Set(
  (import.meta.env.VITE_HARVEST_ADMIN_UIDS ?? "")
    .split(",")
    .map((s: string) => s.trim())
    .filter(Boolean),
);

export function isAdmin(uid: string | null | undefined): boolean {
  if (!uid) return false;
  return ADMIN_UIDS.has(uid);
}
